module.exports = __webpack_public_path__ + "static/media/bus2.b8889197.ogg";